<template>
  <InnerPageLayout>
    <TopPanel>
      <BreadCrumbs :items="items" class="s-bread" />
    </TopPanel>
    <div class="training-container">
      <section v-for="video in videos" :key="video.src" class="video-section">
        <h2 class="video-section__title">{{ video.title }}</h2>
        <p class="video-section__description">{{ video.description }}</p>
        <div class="video-wrapper">
          <iframe
            :src="video.src"
            frameborder="0"
            allow="autoplay; fullscreen; picture-in-picture; clipboard-write; encrypted-media; web-share"
            referrerpolicy="strict-origin-when-cross-origin"
            :title="video.title"
          />
        </div>
      </section>
    </div>
  </InnerPageLayout>
</template>

<script setup lang="ts">
import { ref } from "vue";
import InnerPageLayout from "@/widgets/layouts/InnerPageLayout.vue";
import TopPanel from "@/widgets/sidebars/TopPanel.vue";
import BreadCrumbs from "@/shared/menu/BreadCrumbs.vue";

const items = ref([{ label: "Обучение" }]);

const videos = [
  {
    title: "CDP. Инструкция для клиентов",
    description:
      "Обзор платформы: вход в систему, навигация и основные возможности (сегменты, кампании, дашборды).",
    src: "https://player.vimeo.com/video/1192581235?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    title: "Аналитический отчёт клиента (Конкурентный анализ)",
    description:
      "Как работать с аналитическим отчётом: фильтры, таблицы и графики.",
    src: "https://player.vimeo.com/video/1192565497?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
  },
  {
    title: "Отчет Sales Lift",
    description: "Как работать с отчетом Sales Lift.",
    src: "https://player.vimeo.com/video/1195893631?title=0&byline=0&portrait=0&badge=0&autopause=0&player_id=0&app_id=58479",
  },
];
</script>

<style lang="scss" scoped>
.s-bread {
  margin-left: 18px;
}

.training-container {
  position: relative;
  top: 77px;
  margin-bottom: 24px;
  min-height: 200px;

  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 40px;

  background-color: white;
  border: 1px solid #edecef;
  border-radius: 8px;
  padding: 24px 24px 56px;
}

.video-section {
  width: 100%;
  max-width: 900px;
}

.video-section__title {
  margin: 0 0 8px;
  color: #2b2a5c;
  font-size: 1.125rem;
  font-weight: 600;
  line-height: 1.4;
}

.video-section__description {
  margin: 0 0 16px;
  color: #a19cab;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
}

.video-wrapper {
  width: 100%;

  iframe {
    display: block;
    width: 100%;
    aspect-ratio: 16 / 9;
    border: 0;
    border-radius: 8px;
  }
}
</style>
